import moment from "moment";
import {EditOrderInstructionRequest} from "../medicationmanagement/medications/models/EditOrderInstructionRequest";
import { CommunicareBase} from "./CommunicareBase";


class MedicationsApiV1 extends CommunicareBase {
    
    async editDosageTimes(request:EditOrderInstructionRequest): Promise<any> {
        const path = this.createUrl(['medications',request.medicationAuthoringSystem,request.medicationAuthoringSystemForeignKey,'order-instructions','dosage-times','submit']);
        return await this.AsyncPost(path, request);
    }

    async resetDraftPerformedOn(authoringSystem:string,authoringSystemForeignKey:string): Promise<any> {
        const path = this.createUrl(['service',authoringSystem,authoringSystemForeignKey,'medications','reset-draft-performed-on']);
        let requestBody={
            today:`${moment().format()}`
        }
        let response = await this.AsyncPut(path, requestBody);
        
        return response;
    }
}

const communicareMedicationService = new MedicationsApiV1();
export { communicareMedicationService };